import React from 'react'
import { string, shape } from 'prop-types'
import BannerStatic from 'components/banner-static'

const Banner = ({
  moduleData: {
    altText, linkDestination: { clickThrough: { value } },
    mediaURL: { clickThrough: { value: imageUrl } }, trackingCode,
  },
  className,
  name,
  type,
  moduleId,
}) => {
  const linkPath = { path: value }
  return (<BannerStatic
    link={linkPath}
    trackingCode={trackingCode}
    imageAlt={altText}
    mediaURL={imageUrl}
    className={className}
    name={name}
    type={type}
    moduleId={moduleId}
  />)
}

Banner.propTypes = {
  moduleData: shape({
    altText: string,
    linkDestination: shape({
      clickThrough: shape({
        value: string,
      }),
    }),
    mediaURL: shape({
      clickThrough: shape({
        value: string,
      }),
    }),
    trackingCode: string,
  }).isRequired,
  className: string,
  name: string,
  moduleId: string,
  type: string,
}

Banner.defaultProps = {
  className: '',
  name: null,
  moduleId: null,
  type: null,
}

export default Banner



// WEBPACK FOOTER //
// ./components/cms/components/banner.js